import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  categories: [],
  manufacturers: [],
  sections: [],
  reqProducts: [],
  products: [],
  isLoading: false,
  reqLoading: false
})

const getters = {
  categories: (state) => state.categories,
  manufacturers: (state) => state.manufacturers,
  sections: (state) => state.sections,
  reqProducts: (state) => state.reqProducts,
  products: (state) => state.products,
  isLoading: (state) => state.isLoading,
  reqLoading: (state) => state.reqLoading
}

const mutations = {
  SET_REQUIREMENTS(state, payload) {
    state.categories = payload.categories
    state.manufacturers = payload.manufacturers
    state.sections = payload.sections
    state.reqProducts = payload.products
  },
  SET_PRODUCTS(state, payload) {
    state.products = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_REQ_LOADING(state, payload) {
    state.reqLoading = payload
  }
}

const actions = {
  fetchRequirements({ commit, dispatch }) {
    commit('SET_REQ_LOADING', true)
    axiosWithToken
      .get(`${adminBaseUrl}/requirements/product`)
      .then((res) => {
        commit('SET_REQUIREMENTS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => commit('SET_REQ_LOADING', false))
  },
  fetchProducts({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_PRODUCTS', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createSingleProduct({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/product`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/products')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
        dispatch('fileManager/resetUploads', '', { root: true })
      })
  },
  deleteSingleProduct(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/product/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  fetchSingleProduct({ dispatch }, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/product/${id}`)
      .then((res) => {
        const message = res.data.message
        const product = message.product
        vm.editForm.name_en = product.name_en
        vm.editForm.name_ru = product.name_ru
        vm.editForm.sale_quantity = product.sale_quantity
        vm.editForm.content_en = product.content_en
        vm.editForm.content_ru = product.content_ru
        vm.editForm.categories = message.categories
        vm.editForm.manufacturer_id = product.manufacturer_id
        vm.editForm.sections = message.sections.map((section) => section.id)
        vm.editForm.unit = product.unit
        vm.editForm.price = product.price
        vm.editForm.old_price = product.old_price
        vm.editForm.sale = product.sale
        vm.editForm.active = product.active === 'yes'
        vm.editForm.sequence = product.sequence
        vm.imageUrl = product.image
        vm.editForm.halal = product.halal === 1
        vm.editForm.barcode = product.barcode
        vm.editForm.country_en = product.country_en
        vm.editForm.country_ru = product.country_ru
        vm.editForm.often_taken = product.often_taken.map((i) => i.id)
        vm.editForm.in_stock = product.in_stock
        vm.editForm.not_available_en = product.not_available_en
        vm.editForm.not_available_ru = product.not_available_ru
        vm.editForm.rating = product.rating || 0

        if (product.images && typeof product.images === 'string') {
          try {
            const parsed = JSON.parse(product.images)
            dispatch('fileManager/editUploads', parsed, { root: true })
            // eslint-disable-next-line no-empty
          } catch (ignoreErr) {}
        }
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateSingleProduct(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/product/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/products')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
